import { get } from 'lodash';
import * as queryString from 'query-string-for-all';
export class LazyLoader {
    constructor() {
        this.className = 'lazyload';
        this.imagesToOberserve = null;
        this.backgroundImagesToOberserve = null;
        this.iframesToOberserve = null;
        this.imageCarouselsToObserve = null;
        this.rootMargin = '500px';
        this.imagesToOberserve = document.querySelectorAll('img.' + this.className);
        this.backgroundImagesToOberserve = document.querySelectorAll('.lazyload:not(img):not(iframe):not(.pgb-image-carousel).' + this.className);
        this.iframesToOberserve = document.querySelectorAll('iframe.' + this.className);
        this.imageCarouselsToObserve = document.querySelectorAll('.pgb-image-carousel.' + this.className);
        this.startWatching();
    }
    imageSrc(src, size) {
        const imageSource = queryString.parseUrl(src);
        const widthFactor = this.getSizeFactor();
        const width = this.getSizeFactor() * size;
        if (imageSource.url.indexOf('//images.unsplash.com') !== -1) {
            imageSource.query.w = width.toString();
        }
        else {
            imageSource.query.s = width.toString();
            imageSource.query.o = width.toString();
            imageSource.query.q = 'low';
            if (widthFactor > 1) {
                imageSource.query.q = 'high';
            }
        }
        return queryString.stringifyUrl(imageSource);
    }
    getSizeFactor() {
        return Math.ceil(get(window, 'devicePixelRatio', 1));
    }
    addImageToObserver(image) {
        this.imageObserver.observe(image);
    }
    calculateBackgroundImageSize() {
        const viewportWidth = window.innerWidth;
        return viewportWidth <= 480 ? 300 : viewportWidth <= 768 ? 600 : 1200;
    }
    addBackgroundImageToObserver(iframe) {
        this.backgroundImageObserver.observe(iframe);
    }
    addIframeToObserver(iframe) {
        this.iframeObserver.observe(iframe);
    }
    addImageCarouselToObserver(iframe) {
        this.imageCarouselObserver.observe(iframe);
    }
    loadImage(image) {
        if (image.dataset.src) {
            image.src = image.dataset.src;
        }
        const imageClientWidth = image.parentElement.clientWidth;
        image.src = this.imageSrc(image.src, imageClientWidth);
        if (image.dataset.srcset) {
            image.srcset = image.dataset.srcset;
        }
        image.classList.remove(this.className);
        this.imageObserver.unobserve(image);
    }
    loadIframe(iframe) {
        if (iframe.dataset.src) {
            iframe.src = iframe.dataset.src;
        }
        iframe.classList.remove(this.className);
        this.iframeObserver.unobserve(iframe);
    }
    loadBackgroundImage(element) {
        if (element.dataset.src) {
            element.style.setProperty('--pgb-background-image-url', `url('${this.imageSrc(element.dataset.src, element.clientWidth)}')`);
        }
        element.classList.remove(this.className);
        this.backgroundImageObserver.unobserve(element);
    }
    loadImageCarousel(element) {
        element.classList.remove(this.className);
        const images = element.querySelectorAll('img[data-src]');
        if (images.length) {
            images.forEach(image => {
                if (image.dataset.src) {
                    image.src = this.imageSrc(image.dataset.src, element.clientWidth);
                }
                if (image.dataset.srcset) {
                    image.srcset = image.dataset.srcset;
                }
            });
        }
        this.backgroundImageObserver.unobserve(element);
    }
    startWatching() {
        if ('IntersectionObserver' in window) {
            if (this.imagesToOberserve.length) {
                this.imageObserver = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.loadImage(entry.target);
                        }
                    });
                }, {
                    rootMargin: this.rootMargin,
                });
                this.imagesToOberserve.forEach(image => {
                    this.addImageToObserver(image);
                });
            }
            if (this.iframesToOberserve.length) {
                this.iframeObserver = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.loadIframe(entry.target);
                        }
                    }, {
                        rootMargin: this.rootMargin,
                    });
                });
                this.iframesToOberserve.forEach(iframe => {
                    this.addIframeToObserver(iframe);
                });
            }
            if (this.backgroundImagesToOberserve.length) {
                this.backgroundImageObserver = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.loadBackgroundImage(entry.target);
                        }
                    }, {
                        rootMargin: this.rootMargin,
                    });
                });
                this.backgroundImagesToOberserve.forEach(element => {
                    this.addBackgroundImageToObserver(element);
                });
            }
            if (this.imageCarouselsToObserve.length) {
                this.imageCarouselObserver = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.loadImageCarousel(entry.target);
                        }
                    });
                });
                this.imageCarouselsToObserve.forEach(element => {
                    this.addImageCarouselToObserver(element);
                });
            }
        }
        else {
            // Direct load all images
            // The browser doesn't support IntersectionObserver and the polyfill is not working
            if (this.iframesToOberserve.length) {
                this.iframesToOberserve.forEach(iframe => {
                    this.loadIframe(iframe);
                });
            }
            if (this.imagesToOberserve.length) {
                this.imagesToOberserve.forEach(image => {
                    this.loadImage(image);
                });
            }
            if (this.backgroundImagesToOberserve.length) {
                this.backgroundImagesToOberserve.forEach(element => {
                    this.loadBackgroundImage(element);
                });
            }
            if (this.imageCarouselsToObserve.length) {
                this.imageCarouselsToObserve.forEach(element => {
                    this.loadImageCarousel(element);
                });
            }
        }
    }
}
document.addEventListener('DOMContentLoaded', () => {
    new LazyLoader();
});
